import moment from 'moment-timezone';

export class ReportBankPaymentReconciliation {
	public agentId: string;
	public agentName: string;
	public year: number;
	public month: number;
	public pkAmount: number;
	public qboAmount: number;
	public diffAmount: number;
	public qboVendorId: number;
	public entityRefId: number;

	public date: Date;

	constructor(reportBankPaymentReconciliation: ReportBankPaymentReconciliation) {
		Object.assign(this, reportBankPaymentReconciliation);

		this.date = moment({ year: this.year, month: this.month - 1, day: 1 }).toDate();
	}

	get monthName() {
		return moment(this.date).format('MMMM');
	}

	get key() {
		return `${this.agentId}-${this.agentName}-${this.year}-${this.month}`;
	}
}
